const doc = [({"zh_cn":({"adminConstantHotelDisplayPriceType":({"totalAndPricePerPerson":"总价和人均价", "totalPriceOnly":"仅总价"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;